import gql from 'graphql-tag';

export const SAVED_CREDIT_CARDS_FROM_EMAIL = gql`
  query SavedCreditCards($email: String, $venueId: String) {
    user(email: $email, venueId: $venueId) {
      payload {
        savedCreditCards {
          id
          last4
          fingerprint
          brand
          name
          country
        }
      }
      error
    }
  }
`;
